<template>
  <!-- 产品体系 -->
  <div class="system">
    <div class="header">
      <div class="title">产品体系</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <router-link class="item" v-for="item in systemList" :key="item.id" :to="item.path">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import system1 from "../../../assets/home/system1.png";
import system2 from "../../../assets/home/system2.png";
import system3 from "../../../assets/home/system3.png";
import system4 from "../../../assets/home/system4.png";
import system5 from "../../../assets/home/system5.png";
import system6 from "../../../assets/home/system6.png";

export default {
  setup() {
    return reactive({
      systemList: [
        {
          id: 1,
          title: "畅月数字家园管理系统",
          text: "物业全面数字化智能管理，帮助企业降本增效",
          logo: system1,
          path: "/pc/product/adminsystem"
        },
        {
          id: 2,
          title: "物联网平台",
          text: "多样化硬件对接，整合硬件设备，打破设备信息孤岛，实现智能互联",
          logo: system2,
          path: "/pc/product/things"
        },
        {
          id: 3,
          title: "智慧社区",
          text: "便利的社区增值服务，丰富社区生活的同时提升用户幸福感",
          logo: system3,
          path: "/pc/programme/community"
        },
        {
          id: 4,
          title: "物业APP",
          text: "企业信息化移动办公助手，物业管理更方便、更快捷、更高效",
          logo: system4,
          path: "/pc/product/property"
        },
        {
          id: 5,
          title: "业主APP、小程序",
          text: "APP+小程序全面实现移动办公，物业工作随时处理，效率更高更便捷",
          logo: system5,
          path: "/pc/product/resident"
        },
        {
          id: 6,
          title: "物业工单系统",
          text: "建立企业标准化协作流程，帮助企业高效快速办公",
          logo: system6,
          path: "/pc/product/workorder"
        }
      ]
    });
  }
};
</script>

<style scoped>
.system {
  width: 1180px;
  margin: 80px auto 0;
  text-align: center;
}
.header {
  width: 1180px;
  margin: 0 auto;
}
.header .title {
  font-size: 30px;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}
.body .list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 64px;
}
.body .list .item {
  width: 320px;
  height: 280px;
  background-image: url(../../../assets/home/systemBack.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-bottom: 30px;
  color: #3d3d3d;
}
.body .list .item:hover {
  color: #248efb;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.1);
}
.body .list .item img {
  width: 72px;
  margin-top: 20px;
}
.body .list .item .title {
  font-size: 24px;
  margin-top: 20px;
}
.body .list .item .text {
  width: 260px;
  margin: 40px auto 0;
  color: #495a6c !important;
  line-height: 20px;
}
</style>
